<template>
    <div class="components-container" id="mobileViewPort">
        <div id="mobileMode">
            <div id="titleArea">
                <div class="titleText">成人教育课表</div>
                <div class="titleButton">
                    <el-button class="custom-el-button" type="primary" @click="showHomePage">
                        <i class="el-icon-s-home"></i> 首页
                    </el-button>
                </div>
            </div>
            <div id="queryArea">
                <div class="filter-container">
                    <div class="formItem">
                        <div style="display:inline-block;">
                            <el-select v-model="queryForm.semesterCode" filterable placeholder="学年学期" style="width:60vw;" @change="handleSemesterChange">
                                <el-option v-for="item in xnxqInfo" :key="item.comboValue" :label="item.comboName" :value="item.comboValue">
                                </el-option>
                            </el-select>
                            <el-select v-model="queryForm.weekNum" filterable placeholder="全部周次" style="width:30vw;" @change="handleWeekChange" clearable>
                                <el-option v-for="item in weekInfo" :key="item.comboValue" :label="item.comboName" :value="item.comboValue">
                                </el-option>
                            </el-select>
                        </div>

                    </div>
                </div>
            </div>
            <div id="contentArea"
                 v-loading="timetableLoading"
                 element-loading-text="课表加载中"
                 element-loading-spinner="el-icon-loading"
                 element-loading-background="rgba(0, 0, 0, 0.6)">
                <table id="timetable" class="timetable" :style="{width: (32 * weekDayNum + 40) + 'vw'}">
                    <thead>
                    <tr>
                        <th class="timetableTitle separetor contentHide" colspan="3"></th>
                        <th class="timetableTitle separetor weekDayName contentHide" v-for="(item, index) in weekDayName"
                            v-html="item + (weekDayDate==null?'':('<br/>'+weekDayDate[index]))">
                        </th>
                    </tr>
                    </thead>
                    <tr v-if="forenoonNum > 0" :style="{height: timetableRowHeight + 'px'}">
                        <td class="timetableTitle separetor contentHide" :rowspan="forenoonNum" style="width:10vw;">上<br/><br/>午</td>
                        <td class="timetableTitle contentHide" style="width:10vw;">1</td>
                        <td class="timetableTitle contentHide" style="width:20vw;" v-html="timeQuantum[0]"></td>
                        <td v-for="m in weekDayNum"
                            class="timetableContent"
                            :id="'cell_' + (m-1)"
                            :name="'weekDayNum_' + m"
                            onclick="showDetailInfo(this.id)"></td>
                    </tr>
                    <template v-if="forenoonNum > 1">
                        <tr v-for="n in forenoonNum-1" :style="{height: timetableRowHeight + 'px'}">
                            <td :class="n < forenoonNum-1 ? 'timetableTitle contentHide' : 'timetableTitle separetor contentHide'">{{ n+1 }}</td>
                            <td :class="n < forenoonNum-1 ? 'timetableTitle contentHide' : 'timetableTitle separetor contentHide'"
                                v-html="timeQuantum[n]"></td>
                            <td :class="n < forenoonNum-1 ? '' : 'separetor'"
                                v-for="m in weekDayNum"
                                class="timetableContent"
                                :id="'cell_' + (n*weekDayNum + m-1)"
                                :name="'weekDayNum_' + m"
                                onclick="showDetailInfo(this.id)"></td>
                        </tr>
                    </template>
                    <tr v-if="noonNum > 0" :style="{height: timetableRowHeight + 'px'}">
                        <td class="timetableTitle separetor contentHide" :rowspan="noonNum">中<br/><br/>午</td>
                        <td class="timetableTitle contentHide">1</td>
                        <td class="timetableTitle contentHide" v-html="timeQuantum[forenoonNum]"></td>
                        <td v-for="m in weekDayNum"
                            class="timetableContent"
                            :id="'cell_' + (forenoonNum*weekDayNum + m-1)"
                            :name="'weekDayNum_' + m"
                            onclick="showDetailInfo(this.id)"></td>
                    </tr>
                    <template v-if="noonNum > 1">
                        <tr v-for="n in noonNum-1" :style="{height: timetableRowHeight + 'px'}">
                            <td :class="n < noonNum-1 ? 'timetableTitle contentHide' : 'timetableTitle separetor contentHide'">{{ n+1 }}</td>
                            <td :class="n < noonNum-1 ? 'timetableTitle contentHide' : 'timetableTitle separetor contentHide'"
                                v-html="timeQuantum[forenoonNum+n]"></td>
                            <td :class="n < noonNum-1 ? '' : 'separetor'"
                                v-for="m in weekDayNum"
                                class="timetableContent"
                                :id="'cell_' + (forenoonNum*weekDayNum + n*weekDayNum + m-1)"
                                :name="'weekDayNum_' + m"
                                onclick="showDetailInfo(this.id)"></td>
                        </tr>
                    </template>
                    <tr v-if="afternoonNum > 0" :style="{height: timetableRowHeight + 'px'}">
                        <td class="timetableTitle separetor contentHide" :rowspan="afternoonNum">下<br/><br/>午</td>
                        <td class="timetableTitle contentHide">1</td>
                        <td class="timetableTitle contentHide"
                            v-html="timeQuantum[forenoonNum+noonNum]"></td>
                        <td v-for="m in weekDayNum"
                            class="timetableContent"
                            :id="'cell_' + (forenoonNum*weekDayNum + noonNum*weekDayNum + m-1)"
                            :name="'weekDayNum_' + m"
                            onclick="showDetailInfo(this.id)"></td>
                    </tr>
                    <template v-if="afternoonNum > 1">
                        <tr v-for="n in afternoonNum-1" :style="{height: timetableRowHeight + 'px'}">
                            <td :class="n < afternoonNum-1 ? 'timetableTitle contentHide' : 'timetableTitle separetor contentHide'">{{ n+1 }}</td>
                            <td :class="n < afternoonNum-1 ? 'timetableTitle contentHide' : 'timetableTitle separetor contentHide'"
                                v-html="timeQuantum[forenoonNum+noonNum+n]"></td>
                            <td :class="n < afternoonNum-1 ? '' : 'separetor'"
                                v-for="m in weekDayNum"
                                class="timetableContent"
                                :id="'cell_' + (forenoonNum*weekDayNum + noonNum*weekDayNum + n*weekDayNum + m-1)"
                                :name="'weekDayNum_' + m"
                                onclick="showDetailInfo(this.id)"></td>
                        </tr>
                    </template>
                    <tr v-if="eveningNum > 0" :style="{height: timetableRowHeight + 'px'}">
                        <td class="timetableTitle contentHide" :rowspan="eveningNum">晚<br/><br/>上</td>
                        <td class="timetableTitle contentHide">1</td>
                        <td class="timetableTitle contentHide"
                            v-html="timeQuantum[forenoonNum+noonNum+afternoonNum]"></td>
                        <td v-for="m in weekDayNum"
                            class="timetableContent"
                            :id="'cell_' + (forenoonNum*weekDayNum + noonNum*weekDayNum + afternoonNum*weekDayNum + m-1)"
                            :name="'weekDayNum_' + m"
                            onclick="showDetailInfo(this.id)"></td>
                    </tr>
                    <template v-if="eveningNum > 1">
                        <tr v-for="n in eveningNum-1" :style="{height: timetableRowHeight + 'px'}">
                            <td class="timetableTitle contentHide">{{ n+1 }}</td>
                            <td class="timetableTitle contentHide"
                                v-html="timeQuantum[forenoonNum+noonNum+afternoonNum+n]"></td>
                            <td v-for="m in weekDayNum"
                                class="timetableContent"
                                :id="'cell_' + (forenoonNum*weekDayNum + noonNum*weekDayNum + afternoonNum*weekDayNum + n*weekDayNum + m-1)"
                                :name="'weekDayNum_' + m"
                                onclick="showDetailInfo(this.id)"></td>
                        </tr>
                    </template>
                    <thead>
                    <tr>
                        <th class="timetableTitle separetor contentHide" colspan="3">
                            备注
                        </th>
                        <th  :colspan="weekDayNum+3" style="text-align: left;font-size: 14px;border-width: 1px">
                            <span v-html="remark"/>
                        </th>
                    </tr>
                    </thead>
                </table>
            </div>
            <div id="tipsArea">
                点击单元格可查看课程详情
            </div>
            <el-dialog id="detailDialog" class="formDialog" title="详情" :visible.sync="dialogVisible" v-if="dialogVisible" width="90%">
                <el-scrollbar id="detailDialogScroll" ref="detailDialogScroll">
                    <el-form label-width="80px" label-position="left" width="100%">
                        <el-form-item label="上课时间">{{ courseInfo.time }}</el-form-item>
                        <el-form-item label="课程名称">{{ courseInfo.courseName }}</el-form-item>
                        <el-form-item label="课程类型">{{ courseInfo.courseTypeName }}</el-form-item>
                        <el-form-item label="上课班级">{{ courseInfo.className }}</el-form-item>
                        <el-form-item label="授课教师">{{ courseInfo.teaName }}</el-form-item>
                        <el-form-item label="授课场地">{{ courseInfo.siteName }}</el-form-item>
                        <el-form-item label="授课周次">{{ courseInfo.weekNum }}</el-form-item>
                    </el-form>
                </el-scrollbar>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import {showNotify} from "utils/message";

export default {
    data() {
        return {
            dialogVisible: false,
            //详情
            courseInfo: {
                courseName: null,
                cousseTypeName: null,
                time: null,
                className: null,
                teaName: null,
                siteName: null,
                weekNum: null,
            },
            queryForm: {
                semesterCode: null,
                stuCode: null,
                stuName: null,
                weekNum: null,
                showDivideCourse: false,
            },
            xnxqInfo: [],
            weekInfo: [],
            mainDivHeight: 500,
            timetableHeight: 500,
            timetableRowHeight: 60,
            //课表基本参数
            weekDayNum: null,
            weekDayName: null,
            weekDayDate: null,
            forenoonNum: null,
            noonNum: null,
            afternoonNum: null,
            eveningNum: null,
            totalNum: null,
            forenoonOrderArray: null,
            noonOrderArray: null,
            afternoonOrderArray: null,
            eveningOrderArray: null,
            timeQuantum: [],
            //课表内容
            timetableInfo: null,
            cellContent: [],
            timetableLoading: false,
            allowQueryState: false,
            remark: null,
            curTeaName: '',
        }
    },
    mounted() {
        this.userInfo();
        window.showDetailInfo = this.showDetailInfo;
    },
    methods: {
        showDetailInfo(id) {
            const cellIndex = id.substring(5);
            if (this.timetableInfo[cellIndex].courseName == null) return;

            this.courseInfo.courseName = this.timetableInfo[cellIndex].courseName;
            this.courseInfo.courseTypeName = this.timetableInfo[cellIndex].courseTypeName;
            this.courseInfo.className = this.timetableInfo[cellIndex].className;
            this.courseInfo.teaName = this.timetableInfo[cellIndex].teaName;
            this.courseInfo.siteName = this.timetableInfo[cellIndex].siteName;
            this.courseInfo.weekNum = this.timetableInfo[cellIndex].weekNum;

            //处理时间信息
            this.courseInfo.time = '';
            //日期
            if (this.singleWeek) {
                this.courseInfo.time = this.weekDayDate[cellIndex % this.weekDayNum] + ' / ';
            }
            //星期几
            this.courseInfo.time += this.weekDayName[cellIndex % this.weekDayNum];
            //时间段
            let finalTimeName = '';
            const timeNameIndex = parseInt(this.timetableInfo[cellIndex].orderNum.substring(2), 10) - 1;
            const rowSpanNum = $('#tempTimetable #' + id).attr('rowspan');
            //判断是否为合并单元格
            if (rowSpanNum != undefined) {
                let tempTimeNameArray = new Array();
                for (let i = 0; i < rowSpanNum; i++) {
                    tempTimeNameArray.push(this.timeName[timeNameIndex + i]);
                }

                //合并时间段
                let finalTimeNameArray = new Array();
                for (let i = 0; i < tempTimeNameArray.length; i++) {
                    let isExist = false;
                    const tempTimeName = tempTimeNameArray[i].substring(0, 2);

                    for (let j = 0; j < finalTimeNameArray.length; j++) {
                        if (tempTimeName === finalTimeNameArray[j].substring(0, 2)) {
                            finalTimeNameArray[j] = finalTimeNameArray[j] + '、' + tempTimeNameArray[i].substring(2);
                            isExist = true;
                        }
                    }
                    if (isExist === false) {
                        finalTimeNameArray.push(tempTimeNameArray[i]);
                    }
                }

                //拼接最终结果
                for (let i = 0; i < finalTimeNameArray.length; i++) {
                    finalTimeName += finalTimeNameArray[i].substring(0, 2) + '第 ' + finalTimeNameArray[i].substring(2) + ' 节，';
                }
                finalTimeName = finalTimeName.substring(0, finalTimeName.length - 1);
            } else {
                finalTimeName = this.timeName[timeNameIndex].substring(0, 2) + '第 ' + this.timeName[timeNameIndex].substring(2) + ' 节';
            }
            this.courseInfo.time += ' / ' + finalTimeName;

            this.dialogVisible = true;
        },
        showHomePage() {
            this.$router.push('/m/wx/home');
        },
        //打印
        printFile() {
            this.showLoadingMask("课表信息打印处理中，请稍候...");
            this.$api.timetableManageAdultEducation.stuTimetable.printFile({
                data: this.queryForm
            }).then((res) => {
                if (res.data.data == "Fail") {
                    showNotify('错误', '文件生成失败', 'error', 3000);
                }
                this.basedata = res.data.data;
                let win = window.open(" ");
                win.document.write(this.basedata);
                win.document.close();
                win.print()
                win.close()
            }).catch((err) => {
                console.log(err);
            }).finally(() => {
                this.closeLoadingMask();
            });
        },
        //导出
        exportSingle() {
            this.showLoadingMask("课表信息导出中，请稍候...");
            this.$api.timetableManageAdultEducation.stuTimetable.exportFile({
                responseType: "blob",
                data: this.queryForm
            }).then((res) => {
                const _this = this;
                const resultData = res.data;

                const fileReader = new FileReader();
                fileReader.onload = function () {
                    if (resultData.type == 'application/json') {
                        const jsonData = JSON.parse(fileReader.result); // 说明是普通对象数据，后台转换失败
                        showNotify('错误', jsonData.msg, 'error', 3000);
                    } else {
                        const fileName = decodeURI(res.headers['content-disposition'].split('fileName=')[1]);
                        _this.downloadFile(resultData, fileName);
                    }
                };
                fileReader.readAsText(resultData);
            }).catch((err) => {
                console.log(err);
            }).finally(() => {
                this.closeLoadingMask();
            });
        },
        //获得角色信息
        userInfo() {
            this.$api.system.basic.userInfo({}).then((res) => {
                this.queryForm.stuCode = res.data.data.phone;
                this.queryForm.stuName = res.data.data.name;
                // this.queryForm.stuCode = '112321101';
                this.initCombo();
            }).catch((err) => {
                console.log(err);
            });
        },
        initCombo() {
            this.$api.timetableManageAdultEducation.common.semesterInfo({
                data: {
                    timeType: 'endTime'
                }
            }).then((res) => {
                this.xnxqInfo = res.data.data.semesterComboData;
                this.queryForm.semesterCode = res.data.data.curSemesterCode;
                this.handleSemesterChange(this.queryForm.semesterCode);
            }).catch((err) => {
                console.log(err);
            });
        },
        handleSemesterChange(value) {
            //获取当前学期课表开放查询状态
            this.allowQueryState = false;
            for (const semesterInfo of this.xnxqInfo) {
                if (semesterInfo.comboValue == value) {
                    this.allowQueryState = semesterInfo.otherInfo == '1' ? true : false;

                    if (!this.allowQueryState) {
                        this.$alert("当前所选学期的课表未开放查询", "提示", {
                            confirmButtonText: "确定",
                        });
                    }

                    break;
                }
            }

            this.queryForm.weekNum = null;
            this.loadWeekCombo();
            this.initBlankTimetable();
            if (this.allowQueryState) {
                this.queryStuTimetable();
            } else {
                $('.timetableContent').html('');
            }
        },
        loadWeekCombo() {
            this.$api.timetableManageAdultEducation.common.weekCombo({
                data: this.queryForm
            }).then((res) => {
                this.weekInfo = res.data.data.weekComboData;
            }).catch((err) => {
                console.log(err);
            });
        },
        handleWeekChange() {
            if (this.allowQueryState) {
                this.queryStuTimetable();
            }
        },
        initBlankTimetable() {
            this.$api.timetableManageAdultEducation.common.baseParam({
                data: this.queryForm
            }).then((res) => {
                this.weekDayNum = parseInt(res.data.data.baseParam.weekDayNum, 10);
                this.weekDayName = res.data.data.baseParam.weekDayName.split(',');
                this.forenoonNum = parseInt(res.data.data.baseParam.forenoonNum, 10);
                this.noonNum = parseInt(res.data.data.baseParam.noonNum, 10);
                this.afternoonNum = parseInt(res.data.data.baseParam.afternoonNum, 10);
                this.eveningNum = parseInt(res.data.data.baseParam.eveningNum, 10);
                this.totalNum = this.forenoonNum + this.noonNum + this.afternoonNum + this.eveningNum;
                this.forenoonOrderArray = this.generateOrderDetailInfo(0, this.forenoonNum);
                this.noonOrderArray = this.generateOrderDetailInfo(this.forenoonNum, this.noonNum);
                this.afternoonOrderArray = this.generateOrderDetailInfo(this.forenoonNum + this.noonNum, this.afternoonNum);
                this.eveningOrderArray = this.generateOrderDetailInfo(this.forenoonNum + this.noonNum + this.afternoonNum, this.eveningNum);
                const timeQuantumArray = res.data.data.baseParam.timeQuantum.split(',');
                const _this = this;
                this.timeQuantum = new Array();
                timeQuantumArray.forEach(element => {
                    _this.timeQuantum.push(element.split('@')[1]);
                });
                this.cellContent = new Array(this.weekDayNum * parseInt(res.data.data.baseParam.totalNum, 10));
                //处理时间名称
                this.handleTimeNameInfo();
                //处理节次时间
                this.handleOrderNumTimeInfo(res.data.data.baseParam.timeQuantum);
                this.handleTimetableRowHeight();
            }).catch((err) => {
                console.log(err);
            });
        },
        handleTimeNameInfo(){
            this.timeName = new Array();

            for(let i=0; i<this.forenoonNum; i++){
                // this.timeName.push({
                //     index: orderNumIndex<10 ? ('0'+orderNumIndex) : orderNumIndex,
                //     name: '上午' + (i+1)
                // });
                this.timeName.push('上午' + (i+1));
            }
            for(let i=0; i<this.noonNum; i++){
                this.timeName.push('中午' + (i+1));
            }
            for(let i=0; i<this.afternoonNum; i++){
                this.timeName.push('下午' + (i+1));
            }
            for(let i=0; i<this.eveningNum; i++){
                this.timeName.push('晚上' + (i+1));
            }
        },
        handleOrderNumTimeInfo(tempTimeQuantum){
            const timeQuantumArray = tempTimeQuantum.split(',');
            const _this = this;
            this.timeQuantum = new Array();
            timeQuantumArray.forEach(element => {
                _this.timeQuantum.push(element.split('@')[1].replace('~', '<div style="height:10px; font-size:10px;">|</div>'));
            });
        },
        generateOrderDetailInfo(startIndex, num) {
            let orderArray = new Array();

            for (let i = 0; i < num; i++) {
                let tempOrder = startIndex + i + 1;
                orderArray.push(tempOrder < 10 ? '0' + tempOrder : tempOrder.toString());
            }

            return orderArray;
        },
        handleTimetableRowHeight() {
            //默认高度60，内容高度低于总高度自动拉伸
            const height = $('#contentArea').height();
            //默认高度55，内容高度低于总高度自动拉伸
            if(this.totalNum * 55 < height - 60){
                this.timetableRowHeight = (height - 60) / this.totalNum;
            }else{
                this.timetableRowHeight = 55;
            }
        },
        queryStuTimetable() {
            this.showLoadingMask("课表信息加载中，请稍候...");

            this.$api.timetableManageAdultEducation.query.stu({
                data: this.queryForm
            }).then((response) => {
                this.timetableInfo = response.data.data.timetable.cellList;
                this.weekDayDate = response.data.data.weekdayDate;
                let tempRemark = response.data.data.timetable.remark;
                tempRemark = tempRemark.replace('｜｜', '<br/><br/>');
                this.remark = tempRemark;
                this.$nextTick(() => {
                    this.parseTimetableInfo(this.timetableInfo);
                    this.handleTimetableShow();
                });
            }).catch(error => {
                console.log(error);
                this.closeLoadingMask();
            });
        },
        handleTimetableShow(){
            this.createTempTimetable();
            this.mergeTimetableCell();
            this.fixTable();
            this.timetableLoading = false;
        },
        mergeTimetableCell(){
            let cellArray = $('#tempTimetable .timetableContent');

            for(let i=0; i<this.weekDayNum; i++){
                //获取当天所有单元格
                let curDayCellArray = new Array();
                cellArray.each((index, ele) => {
                    if($(ele).attr('name').substring(11) == (i+1)){
                        curDayCellArray.push(ele);
                    }
                });

                for(let j=0; j<curDayCellArray.length; j++){
                    let curCell = $(curDayCellArray[j]);
                    const curContent = curCell.html();
                    let rowNum = 1;
                    let isSeparetor = false;

                    //判断当前单元格内容为空或者为最后单元格，跳过循环
                    if(curContent==='' || j===curDayCellArray.length-1) continue;

                    //判断当前单元格是否可以与下面时间段的课程合并
                    for(let k=j+1; k<curDayCellArray.length; k++){
                        if(curContent === $(curDayCellArray[k]).html()){
                            if($(curDayCellArray[k]).attr('class').indexOf('separetor') > -1){
                                isSeparetor = true;
                            }else{
                                isSeparetor = false;
                            }

                            $(curDayCellArray[k]).remove();
                            rowNum++;
                        }else{
                            break;
                        }
                    }

                    //判断是否需要合并
                    if(rowNum > 1){
                        curCell.attr('rowspan', rowNum);
                        if(isSeparetor){
                            curCell.addClass('separetor');
                        }

                        //跳过已被合并的单元格
                        j += (rowNum-1);
                    }
                }
            }
        },
        fixTable() {
            const TableID = 'tempTimetable';
            const FixColumnNumber = 3; //要锁定列的个数
            //显示的宽度和高度
            const width = $('#contentArea').width();
            const height = $('#contentArea').height();

            //创建框架
            if ($("#" + TableID + "_tableLayout").length != 0) {
                $("#" + TableID + "_tableLayout").before($("#" + TableID));
                $("#" + TableID + "_tableLayout").empty();
            } else {
                $("#" + TableID).after("<div id='" + TableID + "_tableLayout' style='overflow:hidden; height:" + height + "; width:" + width + ";'></div>");
            }

            $('<div id="' + TableID + '_tableFix"></div>' +
                '<div id="' + TableID + '_tableHead"></div>' +
                '<div id="' + TableID + '_tableColumn"></div>' +
                '<div id="' + TableID + '_tableData"></div>').appendTo("#" + TableID + "_tableLayout");

            const oldtable = $("#" + TableID);
            const tableFixClone = oldtable.clone(true);
            tableFixClone.attr("id", TableID + "_tableFixClone");
            $("#" + TableID + "_tableFix").append(tableFixClone);
            const tableHeadClone = oldtable.clone(true);
            tableHeadClone.attr("id", TableID + "_tableHeadClone");
            $("#" + TableID + "_tableHead").append(tableHeadClone);
            const tableColumnClone = oldtable.clone(true);
            tableColumnClone.attr("id", TableID + "_tableColumnClone");
            $("#" + TableID + "_tableColumn").append(tableColumnClone);
            $("#" + TableID + "_tableData").append(oldtable);
            $("#" + TableID + "_tableLayout table").each(function () {
                $(this).css("margin", "0");
            });

            //计算tableFix，tableHead的高度
            let HeadHeight = $("#" + TableID + "_tableHead thead").height();
            HeadHeight += 2;
            $("#" + TableID + "_tableHead").css("height", HeadHeight);
            $("#" + TableID + "_tableFix").css("height", HeadHeight);

            //计算tableFix，tableColumn的宽度
            let ColumnsWidth = 0;
            $("#" + TableID + "_tableColumn tr:eq(1) td:lt(" + 3 + ")").each(function () {
                ColumnsWidth += $(this).outerWidth(true);
            });
            ColumnsWidth += 2;

            $("#" + TableID + "_tableColumn").css("width", ColumnsWidth);
            $("#" + TableID + "_tableFix").css("width", ColumnsWidth);

            //为tableHead和tableColumn添加联动的滚动条事件
            $("#" + TableID + "_tableData").scroll(function () {
                $("#" + TableID + "_tableHead").scrollLeft($("#" + TableID + "_tableData").scrollLeft());
                $("#" + TableID + "_tableColumn").scrollTop($("#" + TableID + "_tableData").scrollTop());
            });

            $("#" + TableID + "_tableFix").css({"overflow": "hidden", "position": "relative", "z-index": "50"});
            $("#" + TableID + "_tableHead").css({
                "overflow": "hidden",
                "width": width,
                "position": "relative",
                "z-index": "45"
            });
            $("#" + TableID + "_tableColumn").css({
                "overflow": "hidden",
                "height": height,
                "position": "relative",
                "z-index": "40"
            });
            $("#" + TableID + "_tableData").css({
                "overflow": "auto",
                "width": width,
                "height": height,
                "position": "relative",
                "z-index": "35"
            });

            //为较小的table修正样式
            if ($("#" + TableID + "_tableHead").width() > $("#" + TableID + "_tableFix table").width()) {
                $("#" + TableID + "_tableHead").css("width", $("#" + TableID + "_tableFix table").width());
                $("#" + TableID + "_tableData").css("width", $("#" + TableID + "_tableFix table").width());
            }
            if ($("#" + TableID + "_tableColumn").height() > $("#" + TableID + "_tableColumn table").height()) {
                $("#" + TableID + "_tableColumn").css("height", $("#" + TableID + "_tableColumn table").height());
                $("#" + TableID + "_tableData").css("height", $("#" + TableID + "_tableColumn table").height());
            }

            $("#" + TableID + "_tableFix").offset($("#" + TableID + "_tableLayout").offset());
            $("#" + TableID + "_tableHead").offset($("#" + TableID + "_tableLayout").offset());
            $("#" + TableID + "_tableColumn").offset($("#" + TableID + "_tableLayout").offset());
            $("#" + TableID + "_tableData").offset($("#" + TableID + "_tableLayout").offset());

            $('#' + TableID + '_tableData').css('width', width);
            $('#' + TableID + '_tableData').css('height', height);
            $('#tempTimetable_tableData .contentHide').css('color', '#FFFFFF');
            $('#tempTimetable_tableData .contentHide').css('background', '#FFFFFF');
        },
        createTempTimetable(){
            $("#timetable").show();
            const tempTableClone = $("#timetable").clone(true);
            tempTableClone.attr("id", 'tempTimetable');
            $("#timetable").after(tempTableClone);
            $("#timetable").hide();
        },
        parseTimetableInfo(timetableInfo) {
            const _this = this;

            timetableInfo.forEach((cell, index) => {
                let tempCourseName = '';

                if (cell.courseName != null) {
                    if (cell.courseName.indexOf('｜') < 0) {
                        tempCourseName = cell.courseName;
                        /*
                        if (tempCourseName.length > 13) {
                            tempCourseName = tempCourseName.substring(0, 10) + '……';
                        }
                        */
                        if (cell.teaName != null) tempCourseName += '<br/>' + cell.teaName;
                        if (cell.siteName != null) tempCourseName += '<br/>' + cell.siteName.replace('（）', '');
                        if (cell.weekNum != null) tempCourseName += "<br/>" + cell.weekNum;
                    } else {
                        const tempCourseNameArray = cell.courseName.split('｜');
                        const tempTeaNameArray = cell.teaName.split('｜');
                        const tempSiteNameArray = cell.siteName.split('｜');
                        const tempWeekNumArray = cell.weekNum.split('｜');

                        for (let i = 0; i < tempCourseNameArray.length; i++) {
                            tempCourseName += '<br/>';

                            tempCourseName += tempCourseNameArray[i];
                            if (cell.teaName != null && tempTeaNameArray.length > i) tempCourseName += '<br/>' + tempTeaNameArray[i];
                            if (cell.siteName != null && tempSiteNameArray.length > i) tempCourseName += '<br/>' + tempSiteNameArray[i];
                            if (cell.weekNum != null && tempWeekNumArray.length > i) tempCourseName += '<br/>' + tempWeekNumArray[i];

                            tempCourseName += '<br/>';
                        }
                        tempCourseName += '<br/>';
                    }
                }

                document.getElementById('cell_' + index).innerHTML = tempCourseName;
                _this.cellContent[index] = tempCourseName;
            });

            this.mergeCell();
        },
        mergeCell() {
            $('#finalTimetable').empty();
            $('#finalTimetable').append($('#oriTimetable').children().clone());
            $('#oriTimetable').hide();
            this.$nextTick().then(() => {
                $('#finalTimetable').show();
            });

            //修改单元格id
            $('#finalTimetable .timetableContent').each(function () {
                $(this).attr('id', 'final_' + $(this).attr('id'));
            });

            //处理可以合并的单元格
            const lastIndex = this.weekDayNum * this.totalNum - 1;
            for (let i = 0; i < this.weekDayNum; i++) {
                for (let j = 0; j < this.totalNum; j++) {
                    const index = this.weekDayNum * j + i;
                    let curCell = $('#final_cell_' + index);

                    //判断单元格有效并且不是最后单元格
                    if (curCell && this.timetableInfo[index].courseName && index < lastIndex) {
                        let sameFlag = true;
                        let sameNum = 1;
                        let mergeOrderArray = new Array();
                        mergeOrderArray.push(this.timetableInfo[index].orderNum.substring(2));

                        while (sameFlag) {
                            const tempIndex = index + sameNum * this.weekDayNum;
                            if (tempIndex > lastIndex) {
                                break;
                            }

                            let tempCell = $('#final_cell_' + tempIndex);
                            if (curCell.html() === tempCell.html()
                                && this.isSameTimeRange(this.timetableInfo[index].orderNum, this.timetableInfo[tempIndex].orderNum)) {
                                mergeOrderArray.push(this.timetableInfo[tempIndex].orderNum.substring(2));
                                tempCell.remove();
                                sameNum++;
                            } else {
                                sameFlag = false;
                            }
                        }

                        if (sameNum > 1) {
                            curCell.attr('rowspan', sameNum);

                            //判断是否需要添加分割线
                            if (mergeOrderArray[mergeOrderArray.length - 1] === this.forenoonOrderArray[this.forenoonOrderArray.length - 1]
                                || mergeOrderArray[mergeOrderArray.length - 1] === this.noonOrderArray[this.noonOrderArray.length - 1]
                                || mergeOrderArray[mergeOrderArray.length - 1] === this.afternoonOrderArray[this.afternoonOrderArray.length - 1]
                                || mergeOrderArray[mergeOrderArray.length - 1] === this.eveningOrderArray[this.eveningOrderArray.length - 1]
                            ) {
                                curCell.addClass('separetor');
                            }
                        }
                    }
                }
            }

            this.closeLoadingMask();
        },
        isSameTimeRange(orderNum_1, orderNum_2) {
            //判断是否同一天
            let dayNum_1 = orderNum_1.substring(0, 2);
            let dayNum_2 = orderNum_2.substring(0, 2);
            if (dayNum_1 === dayNum_2) {
                //判断是否同一时间区域（上午、中午、下午、晚上）
                let timeNum_1 = orderNum_1.substring(2);
                let timeNum_2 = orderNum_2.substring(2);
                if ((this.forenoonOrderArray.indexOf(timeNum_1) > -1 && this.forenoonOrderArray.indexOf(timeNum_2) > -1)
                    || (this.noonOrderArray.indexOf(timeNum_1) > -1 && this.noonOrderArray.indexOf(timeNum_2) > -1)
                    || (this.afternoonOrderArray.indexOf(timeNum_1) > -1 && this.afternoonOrderArray.indexOf(timeNum_2) > -1)
                    || (this.eveningOrderArray.indexOf(timeNum_1) > -1 && this.eveningOrderArray.indexOf(timeNum_2) > -1)
                ) {
                    return true;
                } else {
                    return false;
                }
            } else {
                return false;
            }
        },
        //显示loading
        showLoadingMask(str) {
            this.loadingMask = this.$loading({
                lock: true,
                text: str,
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.8)",
            });
        },
        //关闭loading
        closeLoadingMask() {
            if (this.loadingMask) this.loadingMask.close();
        },
        alertMsg(str) {
            this.$message({
                message: str,
                type: 'warning'
            });
        },
        downloadFile(data, fileName) {
            let blob = new Blob([data], {type: "application/ms-excel;charset=utf-8"});

            //浏览器兼容，Google和火狐支持a标签的download，IE不支持
            if (window.navigator && window.navigator.msSaveBlob) {
                window.navigator.msSaveBlob(blob, fileName);
            } else {
                let url = URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.setAttribute("href", url);
                link.setAttribute("download", fileName);
                link.click();
                link.remove();
                URL.revokeObjectURL(url);
            }
        },
    },
}
</script>
<style src="styles/mobile.css"></style>
<style scoped>
#mobileMode #queryArea {
    height: 50px;
    margin: 20px 0 0 0;
}

#mobileMode #tipsArea {
    width: 100vw;
    height: 25px;
    line-height: 25px;
    font-size: 14px;
    color: #0055ff;
    text-align: center;
    display: none;
}

#mobileMode #contentArea {
    width: 96%;
    height: calc(100% - 160px);
    margin: 2%;
    border: 1px solid #DCDFE6;
    border-collapse: collapse;
    border-spacing: 0;
    overflow: hidden;
}

.timetable {
    border-collapse: collapse;
    border-spacing: 0;
    text-align: center;
    font-family: Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB, Microsoft YaHei, Arial, sans-serif;
}

.timetable tr {
    height: 50px;
}

.timetable th {
    line-height: 20px;
    text-align: center;
}

.timetable td, .timetable th {
    border-right: 1px solid #DCDFE6;
    border-bottom: 1px solid #DCDFE6;
    padding: 0;
}

.timetableTitle {
    background-color: #F1FAF6;
    font-weight: bold;
}

.separetor {
    border-bottom: 4px double #DCDFE6 !important;
}

.timetableContent {
    width: 195px;
    font-size: 14px;
    word-break: break-all;
}

#mobileMode #detailDialog {
    top: 100px;
}

#mobileMode #detailDialogScroll {
    max-height: 60vh;
    padding: 10px 20px;
}
</style>



// WEBPACK FOOTER //
// stuTimetableAdultEducationMobile.vue?0204b726